import { motion } from 'framer-motion'
import { Lock, Mail, Eye, EyeOff } from 'lucide-react'
import type { LoginStepFormProps } from '@/components/Login/loginTypes'
import { LoginAlerts } from '@/components/Login/LoginAlerts'

export function LoginCredentialsForm({ flow, theme, brandColor }: LoginStepFormProps) {
  return (
    <motion.form
      key="credentials"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      transition={{ duration: 0.3 }}
      onSubmit={flow.handleLoginSubmit}
      className="login-form"
      style={{ display: 'flex', flexDirection: 'column', gap: 20 }}
    >
      <LoginAlerts flow={flow} />

      <div className="login-field">
        <label htmlFor="email">E-mail</label>
        <div className="login-input-wrapper" style={{ position: 'relative' }}>
          <Mail size={16} style={{ position: 'absolute', left: 14, color: theme.textMuted || '#8a8a95', zIndex: 1 }} />
          <input
            id="email"
            name="email"
            type="email"
            inputMode="email"
            autoComplete="username"
            placeholder="seu@email.com.br"
            value={flow.email}
            onChange={(e) => flow.setEmail(e.target.value)}
            required
            autoFocus
            disabled={flow.rateLimit.isLocked}
            spellCheck={false}
          />
        </div>
      </div>

      <div className="login-field">
        <label htmlFor="password">Senha</label>
        <div className="login-input-wrapper" style={{ position: 'relative' }}>
          <Lock size={16} style={{ position: 'absolute', left: 14, color: theme.textMuted || '#8a8a95', zIndex: 1 }} />
          <input
            id="password"
            name="password"
            type={flow.showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            placeholder="••••••••"
            value={flow.password}
            onChange={(e) => flow.setPassword(e.target.value)}
            required
            disabled={flow.rateLimit.isLocked}
            spellCheck={false}
          />
          <button
            type="button"
            className="login-eye-btn"
            onClick={() => flow.setShowPassword(!flow.showPassword)}
            aria-label={flow.showPassword ? 'Ocultar senha' : 'Mostrar senha'}
            style={{
              position: 'absolute',
              right: 12,
              background: 'none',
              border: 'none',
              color: theme.textMuted || '#8a8a95',
              padding: 4,
              cursor: 'pointer',
            }}
          >
            {flow.showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
      </div>

      <div className="login-options" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <label className="login-remember">
          <input
            type="checkbox"
            checked={flow.rememberMe}
            onChange={(e) => flow.setRememberMe(e.target.checked)}
            style={{ width: 16, height: 16, accentColor: brandColor, cursor: 'pointer' }}
          />
          <span>Lembrar de mim</span>
        </label>
        <button
          type="button"
          className="login-forgot"
          onClick={flow.goToForgotPassword}
          style={{ fontSize: '0.82rem', color: brandColor, background: 'none', border: 'none', cursor: 'pointer' }}
        >
          Esqueceu a senha?
        </button>
      </div>

      <button
        type="submit"
        className="login-submit"
        disabled={flow.isAnyPending || flow.rateLimit.isLocked}
        style={{
          background: brandColor,
          boxShadow: `0 4px 15px ${brandColor}4D`,
          opacity: flow.isAnyPending || flow.rateLimit.isLocked ? 0.5 : 1,
          color: '#fff',
        }}
      >
        {flow.isAnyPending ? <span className="login-spinner" /> : 'Entrar'}
      </button>
      <p className="login-recaptcha-note">
        Protegido por reCAPTCHA.{' '}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          Privacidade
        </a>{' '}
        e{' '}
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
          Termos
        </a>{' '}
        do Google.
      </p>
    </motion.form>
  )
}
